<mat-form-field [appearance]="appearance">
  <mat-icon matPrefix *ngIf="icon">
    {{ icon }}
  </mat-icon>
  <mat-label>{{ label }}</mat-label>
  <input type="text" matInput [mask]="mask" [formControlName]="name" (ngModelChange)="change($event)">
</mat-form-field>